module.exports = __webpack_public_path__ + "static/media/americanmodern-big.eedba2e6.png";